/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable no-restricted-syntax */
import React, {
  ChangeEvent,
  // ChangeEventHandler,
  memo,
  useCallback,
  useEffect,
  useState,
} from 'react';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import IconButton from '@material-ui/core/IconButton';
import { FormattedMessage, useIntl } from 'react-intl';
import { map } from 'lodash';
import {
  CircularProgress,
  Divider,
  Grid,
  Tabs,
  Tab,
  Box,
} from '@material-ui/core';
import styles from './manageCustomers.styles';
import { Typography } from '../../components/Typography';
import { Card } from '../../components/Card';
import { Table } from '../../components/Table';
import { WordConfirmationModal } from './components';
import { Button } from '../../components/Button';

import { AddMemberModal } from '../members/components';
// import { validateContactNumber, validateEmail } from '../../helper/validation';
import { SelectDeviceModal } from '../devices/components';
import { AddGroupModal } from '../group/components';
import DeleteConfirmationModal from './components/deleteConfirmationModal';
import EditGroupModal from '../group/components/editGroupModal';
import { IGetMemberResponse, IMembersState } from '../members/members.slice';
import { IGroupsState, emptyGroup } from '../group/groups.slice';
import { IUser } from '../auth/auth.slice';
import { IDevicesState } from '../devices/devices.slice';
import { IRequestParams } from '../../components/types';
import { getUserStatus } from '../../helper/translationFunctions';
import { useUser } from '../../components/form/user-form/use-user';
import { validateUser } from '../../models/validate-user';
import type { User } from '../../models/user';
import DevicesCard from './devices-card';
import { MemberInfoCard } from './member-info-card';

interface TabPanelProps {
  index: number;
  value: number;
}

export const TabPanel: React.FC<TabPanelProps> = (props) => {
  const { children, value, index } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
    >
      {value === index && (
        <Box>
          <Typography variant="body1">{children}</Typography>
        </Box>
      )}
    </div>
  );
};
